@if (state.modifyingCloset()) {
  <div class="atmos-card">
    <div class="atmos-card__header">
      <h2 class="atmos-section__title">Modify closet</h2>
    </div>
    <div class="atmos-card__body">
      <!-- Columns -->
      <div class="field" data-step="103" data-position="bottom-left-aligned">
        <p>Show items in columns. Recommended to match your in-game closet.</p>
        <div class="atmos-btn-group">
          @for (n of [3,4,5,6,7,8]; track n) {
            <button type="button" class="atmos-btn atmos-btn--sm"
              [class.atmos-btn--active]="state.columns() === n"
              (click)="setColumns(n)">{{ n }}</button>
          }
        </div>
      </div>

      <!-- Ongoing items -->
      <div class="field" data-step="104" data-position="bottom-left-aligned">
        <p>Include ongoing cosmetics (slightly darkened) when showing your items?</p>
        <div class="field__actions">
          <button type="button" class="atmos-btn atmos-btn--sm" (click)="toggleOngoing()">
            <mat-icon>{{ state.showOngoing() ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
            <span>Include ongoing items</span>
          </button>
        </div>
      </div>

      <!-- Sync -->
      <div class="field" data-step="105" data-position="bottom-left-aligned">
        <p>
          Sync this closet with your tracked Sky Planner items, or click items below to manually toggle them.
        </p>
        <div class="field__actions">
          <div class="atmos-btn-group">
            <button type="button" class="atmos-btn atmos-btn--sm" (click)="toggleSync()">
              <mat-icon>{{ state.shouldSync() ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
              <span>Sync closet</span>
            </button>
            <button type="button" class="atmos-btn atmos-btn--sm atmos-btn--danger" (click)="resetSync()">Reset</button>
          </div>
          <button type="button" class="atmos-btn atmos-btn--sm" (click)="closePanel()" data-step="106" data-position="bottom-right-aligned">
            <mat-icon>done</mat-icon>
            <span>Done</span>
          </button>
        </div>
      </div>
    </div>
  </div>
}
